import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { PaymentLookupStatus } from '~direct-debits/models';

interface ComponentProps {
  // Accept either a row carrying `status` (table-view custom cell shape) or
  // a direct status prop. Either form may be null/undefined when the API has
  // no status to report (e.g. a payment row that has not started processing).
  row?: { status: PaymentLookupStatus | null | undefined };
  status?: PaymentLookupStatus | null;
}

// Bootstrap 5's `--bs-secondary` — the neutral grey used for the "no status" placeholder.
// Hard-coded so the placeholder doesn't drift if the theme is recoloured (the theme is
// scoped to live data; placeholders should stay neutral).
const PLACEHOLDER_GREY = '6c757d';
const PLACEHOLDER_STATUS: PaymentLookupStatus = { tag: 'none', name: '—', colour: PLACEHOLDER_GREY };

// Thin wrapper over the shared LookupStatusBadge that adds the null-status
// placeholder behaviour expected by the payment-batches UI.
const PaymentStatusBadge: React.FC<ComponentProps> = ({ row, status }) => {
  const value = row?.status ?? status ?? null;

  if (!value) {
    return <LookupStatusBadge status={PLACEHOLDER_STATUS} dataCy="dd-payment-status-none" />;
  }

  return <LookupStatusBadge status={value} dataCy={`dd-payment-status-${value.tag}`} />;
};

export default PaymentStatusBadge;
